import React from 'react';
import { AuthContext } from '../../authContext';
export const useToken = () => {
    const { token, setToken } = React.useContext(AuthContext);
    return [token, setToken];
};
